<template>
  <button class="buy-now__shared" @click="onConnectClicked()">CONNECT</button>
</template>

<script>
export default {
  methods: {
    async onConnectClicked() {
      await this.$store.dispatch('auth/connectWallet')
    }
  }
}
</script>
